import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { CoreStore } from '@gamiphy/loyalty-station-desktop/store/core';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { getThemeFontStyleSheets, useLSTheme } from '@gamiphy/loyalty/theme';
import FloatingIcon from './components/FloatingIcon';

const FloatingIconFrame: React.FC = observer(() => {
  const muiTheme = useLSTheme({
    dir: AppStore.dir,
    coretavaTheme: ThemeStore.theme,
  });

  return !CoreStore.initialized ? null : (
    <FramePortal
      stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
      theme={muiTheme}
      dir={AppStore.dir}
    >
      <FloatingIcon />
    </FramePortal>
  );
});

export default FloatingIconFrame;
